module.exports = __webpack_public_path__ + "img/image12.b10e51c6.jpg";